module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("h7aMR"))).then(() => parcelRequire('fDow6'));